import tw from "twin.macro";
export const PrimaryButton = tw.button`px-4 py-1 rounded bg-brand-700 text-white hocus:bg-brand-700 hocus:text-white focus:shadow-outline focus:outline-none transition duration-300`;

export const LinkButton = tw.button`px-0 py-0 bg-transparent text-sm text-blue-500 hocus:text-blue-700 focus:outline-none transition duration-300`;

